import React from 'react';
import PageGrid from 'shared/grids/old/PageGrid';
import { GridColumn } from '@progress/kendo-react-grid';
import Modal from 'shared/modals/Modal';

const initialSort = [
  { field: 'name', dir: 'asc' },
];

const QuoteLanesModal = ({
  quote,
  onQuoteLaneSelected,
  onClose,
}) => {
  const handleRowSelect = (selectedQuoteLane) => {
    if (!selectedQuoteLane || selectedQuoteLane?.status !== 'Accepted') {
      return;
    }

    if (onQuoteLaneSelected) {
      onQuoteLaneSelected(selectedQuoteLane);
      onClose();
    }
  };

  const getData = () => Promise.resolve({
    data: quote?.quoteLanes,
    total: quote?.quoteLanes?.length,
  });

  return (
    <Modal isOpen title="Select Quote Lane" handleClose={onClose} containerStyle='medium' width={700}>

      <div style={{ marginBottom: '0.5rem' }}>
        <small style={{ fontSize: 'small' }}>
          <span style={{ fontWeight: 'bold' }}>Note:</span> Only Accepted Quote Lanes can be selected
        </small>
      </div>

      <PageGrid
        name="Select Quote Lane"
        getData={getData}
        searchParams={{}}
        onRowSelect={handleRowSelect}
        initialSort={initialSort}
        rowDisable={(dataItem) => dataItem?.status !== 'Accepted'}
      >
        <GridColumn title="Name" field="name" />
        <GridColumn title="Status" field="status" />
      </PageGrid>
    </Modal>
  );
};

export default QuoteLanesModal;